import { UseQueryResult, useQuery } from 'react-query'
import request from '../../../request'
import { useBuildQueryParams } from '../../../../lib/hooks/useBuildQueryParams'
import { useDealership } from '../../../../store/zustand/dealershipStore'

type ResultType = {
  connectedGA4Accounts: Array<{
    id: string
    name: string
    properties: Array<{
      id: string
      name: string
    }>
  }>
  overallMetrics: {
    active_users: number
    conversions: number
    new_users: number
    screen_page_views: number
    sessions: number
    engaged_sessions: number
    time_per_session: number
    pages_per_session: number
  }
  dailyMetrics: Array<{
    date: string
    active_users: number
    new_users: number
    screen_page_views: number
    engaged_sessions: number
  }>
  eventMetrics: Array<{
    event_name: string
    event_count: number
  }>
  utmMetrics: Array<{
    type: 'utm_medium' | 'utm_source' | 'utm_campaign'
    value: string
    count: number
  }>
}
export const useGetGA4Metrics = ({
  filters,
}: {
  filters?: Record<string, unknown>
}): UseQueryResult<ResultType, Error> => {
  const dealership = useDealership()
  const queryParams = useBuildQueryParams(filters)

  return useQuery<ResultType, Error>(
    ['performance', 'site', 'ga4', 'metrics', { queryParams }],
    ({ signal }) =>
      request<ResultType>({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/performance/site/ga4/metrics`,
        method: 'GET',
        signal,
        params: {
          ...queryParams,
        },
      }),
    {
      keepPreviousData: true,
    },
  )
}
